<div class="subscription-wrapper"
  [ngClass]="{'credit-card-entry-layout': !isPlanMode, 'plan-change-layout': isPlanMode}">
  <!-- While the user refresh resolves the real card-on-file state, show a loader
       instead of the body so the modal doesn't open on one layout (card entry) and
       visibly swap to the other (plan change) once the refresh lands. The body uses
       [hidden] (not *ngIf) so the Stripe card mount point stays in the DOM. -->
  <div class="card-state-loader" *ngIf="isResolvingCardState">
    <rosie-loader [config]="{show: true, full: false, size: 'md', icon: false}"></rosie-loader>
  </div>
  <div [hidden]="isResolvingCardState" *ngIf="!isPlanMode">
    <div class="plan-selection-heading-wrapper">
      <div class="plan-selection-heading d-flex align-items-center justify-content-between w-100">
        <span>{{hasTrialExpired ?
          'Activate
          3-day Trial Extension' : 'Enter your payment info
          below.'}}</span>
        <ng-icon *ngIf="!hasTrialExpired" class="close-icon-wrapper" [name]="'heroXMark'" [size]="'18px'"
          [color]="'#822AC6'" [strokeWidth]="'1'" (click)="closeSubscriptionModal()"></ng-icon>
      </div>
    </div>
  </div>
  <div class="payment" [hidden]="isResolvingCardState">
    <rosie-subscription-plans-checkout *ngIf="!isMobileVersion" class="d-block subscription-plans-checkout"
      [hideChangePlan]="isUpgradeToPlanActive" [showSelectedPlan]="true"
      [showWebsiteTextingAddon]="!isPlanMode && shouldShowWebsiteTextingAddon"></rosie-subscription-plans-checkout>
    <div [ngClass]="{'credit-card-wrapper': !isPlanMode, 'plan-change-wrapper': isPlanMode}">
      <div class="trial-ends-info" *ngIf="isTrialing && !hasCreditCardOnFile">
        <b> You won’t be charged until your trial is over.</b> Switch plans, or cancel anytime.
      </div>
      <rosie-subscription-plans-checkout *ngIf="isMobileVersion" [hideChangePlan]="isUpgradeToPlanActive"
        class="subscription-plans-checkout" [ngClass]="{'d-none': isPlanMode, 'd-block': !isPlanMode}"
        [showSelectedPlan]="true" [showWebsiteTextingAddon]="!isPlanMode && shouldShowWebsiteTextingAddon"></rosie-subscription-plans-checkout>
      <ng-container *ngIf="isPlanMode">
        <ng-container *ngIf="isCanceled && selectedPlan">
          <div class="subscription-canceled-plan">
            <div class="d-flex justify-content-between sub-item" *ngIf="selectedPlan">
              <div class="subscription-price-label new-plan">Plan</div>
              <div class="subscription-price-value new-plan">{{selectedPlan?.name}}</div>
            </div>
            <div class="d-flex justify-content-between sub-item mb-0" *ngIf="selectedPlan">
              <div class="subscription-price-label">Price</div>
              <div class="subscription-price-value">{{getLicensedPlanPrice(selectedPlan)}}/mo</div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!isCanceled">
          <div class="plan-selection-heading-wrapper">
            <div class="plan-selection-heading d-flex align-items-center justify-content-between w-100">Change your plan
              <ng-icon class="close-icon-wrapper" [name]="'heroXMark'" [size]="'20px'" [color]="'#A89FB3'"
                [strokeWidth]="'2'" (click)="closeSubscriptionModal()"></ng-icon>
            </div>
          </div>
          <div class="subscription-info-box" *ngIf="isTrialing && hasCreditCardOnFile">
            <img class="icon question" [src]="'assets/images/info-icon-circle.svg'">
            <div class="" [innerHTML]="trialEndDate
              ? ('SUBSCRIPTION.CHARGED_UNTIL_TRIAL_DATE' | translate: {trialEndDate: (trialEndDate | dateFormat:'longDate')})
              : ('SUBSCRIPTION.CHARGED_UNTIL_TRIAL' | translate)"></div>
          </div>
          <div class="d-flex justify-content-between sub-item" *ngIf="hasAnyChange">
            <div class="subscription-price-label new-plan">New Plan</div>
            <div class="subscription-price-value new-plan">{{selectedPlan?.name}}</div>
          </div>
          <div class="d-flex justify-content-between sub-item" *ngIf="hasAnyChange">
            <div class="subscription-price-label">New Price</div>
            <div class="subscription-price-value" [shimmer]="isCouponRevalidating">{{getSelectedPlanPrice()}}</div>
          </div>
          <div class="d-flex justify-content-between sub-item" *ngIf="isDowngrade && !isTrialing && planRenewalDate">
            <div class="subscription-price-label">Next Billing Date</div>
            <div class="subscription-price-value">{{planRenewalDate | dateFormat:false: true}}</div>
          </div>
          <rosie-coupon-code *ngIf="hasAnyChange && currentSubscriptionId" [subscriptionId]="currentSubscriptionId"
            (onCouponApplied)="handleCouponApplied()" (onCouponRemoved)="handleCouponRemoved()">
          </rosie-coupon-code>
          <div class="amount-due-today" *ngIf="isUpgrade && !isTrialing">
            <div class="d-flex align-items-center amount-due-today-wrapper">
              <div class="amount-due-today-heading">Amount Due Today</div>
              <img class="icon" [src]="'assets/images/info-grey.svg'"
                [ngbTooltip]="'The difference between plans, prorated based on days left in your billing cycle.'"
                tooltipClass="tooltip-wrapper">
            </div>
            <div class="d-flex justify-content-between sub-item"
              [shimmer]="isLoadingInvoice && !invoicePreview?.proration">
              <div class="subscription-price-label smaller">{{initialPlan}} plan credit</div>
              <div class="subscription-price-value">{{invoicePreview?.proration || '$0'}}
              </div>
            </div>
            <div class="d-flex justify-content-between sub-item"
              [shimmer]="isLoadingInvoice && !invoicePreview?.subtotal">
              <div class="subscription-price-label smaller">Prorated {{selectedPlan?.name}} charge</div>
              <div class="subscription-price-value">{{invoicePreview?.subtotal || '$0'}}
              </div>
            </div>
            <div class="d-flex justify-content-between sub-item" *ngIf="invoicePreview?.discount"
              [shimmer]="isLoadingInvoice && !invoicePreview?.discount">
              <div class="subscription-price-label smaller">Promo Code Discount</div>
              <div class="subscription-price-value">- {{invoicePreview?.discount || '$0'}}
              </div>
            </div>
            <div class="d-flex justify-content-between sub-item total-wrapper"
              [shimmer]="isLoadingInvoice  && !invoicePreview?.total">
              <div class="subscription-price-label total">Total</div>
              <div class="subscription-price-value">{{invoicePreview?.total || '$0'}}</div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <div [hidden]="isExternalBillingProvider || (hasCreditCardOnFile && !isCanceled && !isPaymentMethodInvalid)" class="credit-cards-single-wrapper"
        [ngClass]="{'canceled-margin': isCanceled}">
        <div class="heading d-flex align-items-center justify-content-between flex-wrap">
          {{'SUBSCRIPTION.PAYMENT_DETAILS' | translate }}
          <img class="credit-cards-image" [src]="'assets/images/credit-cards.png'">
        </div>
        <div class="rosie-pymt-container" [hidden]="!isInitializingPaymentMethod">
          <div [ngClass]="{'shimmer single-plan-loader': isInitializingPaymentMethod}"
            class="rosie-pymt-loader-container">
            <div *ngFor="let i of [].constructor(4)" [shimmer]="isInitializingPaymentMethod"
              class="rosie-pymt-loader-item">
            </div>
          </div>
        </div>
        <form class="rosie-credit-card">
          <div [hidden]="isInitializingPaymentMethod">
            <div class="form-group credit-card-number">
              <span #cardElement class="form-control rosie-form-control no-border" id="card-number"></span>
              <span [id]="getErrorElId('card-number')" class="rosie-error-message"></span>
              <label class="rosie-form-control-label" for="card-number">
                {{ 'SUBSCRIPTION.CARD_NUMBER_LABEL' | translate }}
              </label>
            </div>
            <div class="d-flex gap-2 single-plan-fields-row">
              <div class="form-group single-plan-field-small">
                <span class="form-control rosie-form-control no-border" id="card-expiry"></span>
                <span [id]="getErrorElId('card-expiry')" class="rosie-error-message"></span>
                <label class="rosie-form-control-label" for="card-expiry">
                  {{ 'SUBSCRIPTION.EXPIRY_DATE_LABEL' | translate }}
                </label>
              </div>
              <div class="form-group single-plan-field-small">
                <span class="form-control rosie-form-control no-border" id="card-cvc"></span>
                <span [id]="getErrorElId('card-cvc')" class="rosie-error-message"></span>
                <label class="rosie-form-control-label" for="card-cvc">
                  {{ 'SUBSCRIPTION.CVC_LABEL' | translate }}
                </label>
              </div>
              <div class="form-group mb-0 single-plan-field-large">
                <input id="card-zip" class="form-control rla-form-control" [formControl]="cardholderForm.get('zip')">
                <rosie-validation-error
                  [show]="cardholderForm.get('zip').errors?.required && cardholderForm.get('zip').touched"
                  [translationKey]="'COMMON.VALIDATION.REQUIRED'"
                  [translationAttributes]="{value: 'ZIP code' | translate}">
                </rosie-validation-error>
                <label class="rosie-form-control-label" for="card-zip">
                  {{ 'SUBSCRIPTION.ZIP' | translate }}
                </label>
              </div>
            </div>
          </div>
          <rosie-alert [message]="paymentError" [type]="'error'" *ngIf="paymentError"
            class="mt-4 d-block"></rosie-alert>
        </form>
        <ng-container>
          <rosie-coupon-code [control]="cardholderForm.get('couponCode')" [displayStyle]="'detailed'"
            (onCouponRemoved)="handleCouponRemoved()">
          </rosie-coupon-code>
          <div class="action-wrapper-line">
            <div class="terms-of-service-text">
              {{getTermsOfServiceText()}}<a href='https://heyrosie.com/legal/terms' target='_blank' class='link'>Terms
                of
                Service </a>
            </div>
            <rosie-button (click)="subscribe()" [inProgress]="inProgress || isInitializingPaymentMethod"
              [translationKey]="hasTrialExpired ? 'Extend Trial' : 'Save Payment Info'" [fullWidth]="true"
              class="d-block subscribe-credit-card-button wide mt-3">
            </rosie-button>
          </div>
        </ng-container>
      </div>
      <div class="upgrade-downgrade-button" *ngIf="!isCanceled">
        <div class="subscription-info-box" *ngIf="isPlanMode && isDowngrade && !hasOnlyIntervalChange">
          <div class="icon">
            <ng-icon [name]="'heroExclamationCircleSolid'" [size]="'20px'" [color]="'#F43F5E'"></ng-icon>
          </div>
          <div *ngIf="isTrialing">Downgrading immediately <b>deactivates all features</b> not included in the new plan.
          </div>
          <div *ngIf="!isTrialing">On {{planRenewalDate | dateFormat:false: true}} all features not included in the new
            plan will be deactivated.</div>
        </div>
        <rosie-button *ngIf="isPlanMode" (click)="handlePlanChange()" [inProgress]="inProgress"
          [translationKey]="getUpgradeButtonText()" [disabled]="!hasAnyChange" class="d-block w-100 mt-4">
        </rosie-button>
      </div>
    </div>
  </div>